import {
    CREATE_SERVICE_LOADING,
    CREATE_SERVICE_FAILED,
    CREATE_SERVICE_SUCCESS
    } from "../types"
    
    const initialState = {
      loading: false,
      error: false,
      message: null,
      success: false
    }
    
    export default function (state = initialState, action) {
      switch (action.type) {
        case CREATE_SERVICE_LOADING:
          return {
            ...state,
            loading: true,
            error: false,
            message: null,
            success: false
          }
        case CREATE_SERVICE_FAILED:
          return {
            ...state,
            loading: false,
            error: true,
            message: action.payload,
            success: false
          }
        case CREATE_SERVICE_SUCCESS:
          return {
            ...state,
            loading: false,
            error: false,
            message: null,
            success: true
          }
        default:
          return state
      }
    }